
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Tickets from './components/Tickets';
import Schedule from './components/Schedule';
import Designers from './components/Designers';
import Experience from './components/Experience';
import Venue from './components/Venue';
import Contact from './components/Contact';
import About from './components/About';
import Sponsors from './components/Sponsors';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Tickets />
      <Schedule />
      <Designers />
      <Experience />
      <Venue />
      <Contact />
      <About />
      <Sponsors />
      <Footer />
    </div>
  );
}
